import React, { useRef, useState } from 'react';
import { Input, Label } from './Input.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const InputBox = ({
    label,
    id,
    showAstrisk = false,
    placeholder = '',
    type = 'text',
    autoFocus = false,
    disabled = false,
    labelStyle = {},
    containerStyle = {},
    inputStyle = {},
    validateInput = (value) => true, // Validation function (default: always valid)
    ...rest
}) => {
    const inputRef = useRef(null);
    const [isInvalid, setIsInvalid] = useState(false); // Track validation state

    useEffectWithErrorLogging(() => {
        if (autoFocus && inputRef.current && !disabled) {
            inputRef.current.focus();
        }
    }, [autoFocus, disabled]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setIsInvalid(!validateInput(value)); // Update validation state based on input
    };

    return (
        <>
            {label && (
                <Label
                    style={{
                        ...labelStyle,
                        color: disabled ? '#a1a1a1' : labelStyle.color,
                    }}
                >
                    {label} {showAstrisk && <span style={{ color: 'red' }}>*</span>}
                </Label>
            )}
            <Input
                ref={inputRef}
                placeholder={placeholder}
                type={type}
                id={id}
                disabled={disabled}
                onChange={handleInputChange} // Handle input change for validation
                style={{
                    ...inputStyle,
                    backgroundColor: disabled ? '#f5f5f5' : inputStyle.backgroundColor,
                    cursor: disabled ? 'not-allowed' : 'text',
                    border: isInvalid ? '1px solid red' : inputStyle.border || '1px solid #d3d3d3', // Red border for invalid input
                    outline: 'none'
                }}
                {...rest}
            />
        </>
    );
};

export default InputBox;